import React from "react";
import { useContent } from "../context/ContentContext";
import { resolveImage } from "../lib/api";
import { Reveal } from "../components/Reveal";
import RichText from "../components/RichText";
import Gallery from "../components/Gallery";
import InstagramSection from "../components/InstagramSection";

const journeyFallback = [
  "https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=1000&q=80",
  "https://images.unsplash.com/photo-1522413452208-996ff3f3e740?w=1000&q=80",
  "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1000&q=80",
  "https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=1000&q=80",
];

const Journey = () => {
  const { content } = useContent();
  const j = content?.journey || {};
  const chapters = j.chapters || [];

  return (
    <div data-testid="journey-page">
      <section className="pt-40 pb-20 md:pt-52 md:pb-28">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal>
            <span className="uppercase tracking-[0.3em] text-xs text-dusty font-bold">{j.kicker}</span>
            <h1 className="font-serif text-5xl md:text-8xl text-navy tracking-tighter mt-4 max-w-4xl leading-[0.95]">{j.title}</h1>
          </Reveal>
        </div>
      </section>

      {chapters.map((c, i) => {
        const reverse = i % 2 === 1;
        return (
          <section
            key={c.id}
            id={c.id}
            className="scroll-mt-28 py-16 md:py-24 border-t border-border/60"
            data-testid={`journey-${c.id}`}
          >
            <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
              <Reveal className={reverse ? "lg:order-2" : ""}>
                <div className="flex items-baseline gap-5 mb-6">
                  <span
                    className="font-serif text-7xl md:text-8xl text-transparent leading-none"
                    style={{ WebkitTextStroke: "1.5px rgba(91,126,148,0.5)" }}
                  >
                    {c.number}
                  </span>
                  <h2 className="font-serif text-3xl md:text-4xl text-navy">{c.title}</h2>
                </div>
                <RichText html={c.bodyHtml} className="text-lg text-navy max-w-lg" />
              </Reveal>
              <Reveal delay={0.1} className={reverse ? "lg:order-1" : ""}>
                <div className={`relative aspect-[4/5] overflow-hidden shadow-[0_30px_70px_rgba(38,62,76,0.15)] ${i % 2 === 0 ? "arch-top rounded-b-lg" : "rounded-lg"}`}>
                  <img src={resolveImage(c.imageUrl)} alt={c.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </Reveal>
            </div>
          </section>
        );
      })}

      <section id="gallery" className="scroll-mt-28 py-24 md:py-32 bg-white border-t border-border/60">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="mb-12 text-center">
            <span className="uppercase tracking-[0.3em] text-xs text-dusty font-bold">Snapshots</span>
            <h2 className="font-serif text-4xl md:text-5xl text-navy mt-3">Along the way</h2>
          </Reveal>
          <Gallery category="journey" fallback={journeyFallback} />
        </div>
      </section>

      <InstagramSection />
    </div>
  );
};

export default Journey;
